import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=35a2ca47&"
import script from "./CardIcon.vue?vue&type=script&lang=js&"
export * from "./CardIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports